import _slicedToArray from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _inherits from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/setPrototypeOf";
import _defineProperty from "/home/jenkins/jenkins_home/workspace/INSi-Consult-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _documentStatusesLabe;
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) k++; groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) { result.groups = buildGroups(result, this); var indices = result.indices; indices && (indices.groups = buildGroups(indices, this)); } return result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { var group = groups[name]; return "$" + (Array.isArray(group) ? group.join("$") : group); })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }
import moment from 'moment';
import { isReady } from '../common';
export var documentStatuses = {
  ALL: 0,
  APPROVED: 1,
  DEPRECATED: 2,
  ARCHIVED: 4
};
export var findDocumentParamsDefault = {
  status: documentStatuses.APPROVED,
  submissionStartDate: '',
  submissionStartDateHour: '00:00:00',
  submissionEndDate: '',
  submissionEndDateHour: '23:59:59',
  creationStartDate: '',
  creationStartDateHour: '00:00:00',
  creationEndDate: '',
  creationEndDateHour: '23:59:59',
  actStartDate: '',
  actStartDateHour: '00:00:00',
  actEndDate: '',
  actEndDateHour: '23:59:59',
  patientHidden: false,
  guardianHidden: false,
  healthcareProfessionalHidden: false,
  categories: null,
  selectedDateRangePreset: 'default',
  showCategoryFilters: false,
  title: '',
  author: '',
  specialty: '',
  sortDate: 'submissionDate'
};
export var documentStatusesLabel = (_documentStatusesLabe = {}, _defineProperty(_documentStatusesLabe, documentStatuses.ALL, 'Tous'), _defineProperty(_documentStatusesLabe, documentStatuses.APPROVED, 'Approuvé'), _defineProperty(_documentStatusesLabe, documentStatuses.DEPRECATED, 'Obsolète'), _defineProperty(_documentStatusesLabe, documentStatuses.ARCHIVED, 'Archivé'), _documentStatusesLabe);
export var documentVisibilityStatuses = {
  ALL: 0,
  NORMAL: 1,
  PATIENT_HIDDEN: 2,
  HEALTCARE_PROFESSIONAL_HIDDEN: 4,
  GUARDIAN_HIDDEN: 8
};
var uniqueUUidSeparator = '__';
export var isHiddenFor = function isHiddenFor(visibility, populationVisibityStatus) {
  return (visibility & populationVisibityStatus) === populationVisibityStatus;
};
export var calculateVisibility = function calculateVisibility(patientHidden, healthcareProfessionalHidden, guardianHidden) {
  var forUpload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!patientHidden && !healthcareProfessionalHidden && !guardianHidden) {
    return forUpload ? documentVisibilityStatuses.NORMAL : null;
  }
  return (patientHidden ? documentVisibilityStatuses.PATIENT_HIDDEN : 0) + (healthcareProfessionalHidden ? documentVisibilityStatuses.HEALTCARE_PROFESSIONAL_HIDDEN : 0) + (guardianHidden ? documentVisibilityStatuses.GUARDIAN_HIDDEN : 0);
};

/**
 * Test if ps owns the document
 * @param document
 * @param psId
 * @returns {*}
 */
export var ownsDocument = function ownsDocument(document, psId) {
  return document.Authors.some(function (item) {
    return item.s_hpInternalId === psId;
  });
};
var formatDate = function formatDate(date) {
  var _date$match = date.match( /*#__PURE__*/_wrapRegExp(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})(.*)/, {
      day: 1,
      month: 2,
      year: 3
    })),
    _date$match$groups = _date$match.groups,
    day = _date$match$groups.day,
    month = _date$match$groups.month,
    year = _date$match$groups.year;
  if (day === '00' && month === '00') return year;
  if (day === '00') return "".concat(year).concat(month);
  return moment(date, 'DD/MM/YYYYHH:mm:ss').utc().format('YYYYMMDDHHmmss');
};
export var formatSearchParams = function formatSearchParams(findDocumentsParams) {
  var ins = findDocumentsParams.ins,
    status = findDocumentsParams.status,
    submissionStartDate = findDocumentsParams.submissionStartDate,
    submissionEndDate = findDocumentsParams.submissionEndDate,
    creationStartDate = findDocumentsParams.creationStartDate,
    creationEndDate = findDocumentsParams.creationEndDate,
    actStartDate = findDocumentsParams.actStartDate,
    actEndDate = findDocumentsParams.actEndDate,
    submissionStartDateHour = findDocumentsParams.submissionStartDateHour,
    submissionEndDateHour = findDocumentsParams.submissionEndDateHour,
    creationStartDateHour = findDocumentsParams.creationStartDateHour,
    creationEndDateHour = findDocumentsParams.creationEndDateHour,
    actStartDateHour = findDocumentsParams.actStartDateHour,
    actEndDateHour = findDocumentsParams.actEndDateHour,
    patientHidden = findDocumentsParams.patientHidden,
    healthcareProfessionalHidden = findDocumentsParams.healthcareProfessionalHidden,
    guardianHidden = findDocumentsParams.guardianHidden,
    categories = findDocumentsParams.categories,
    lastSearchTimestamp = findDocumentsParams.lastSearchTimestamp;
  var submissionStartDatetime = null;
  if (!submissionStartDate && !submissionEndDate && !creationStartDate && !creationEndDate && !actStartDate && !actEndDate && lastSearchTimestamp) {
    var lastSearchTimestampMoment = moment(lastSearchTimestamp).utc();
    submissionStartDatetime = lastSearchTimestampMoment.format('YYYYMMDDHHmmss');
  } else if (submissionStartDate) {
    submissionStartDatetime = formatDate(submissionStartDate + submissionStartDateHour);
  }
  return {
    s_ins: ins,
    i_visibility: calculateVisibility(patientHidden, healthcareProfessionalHidden, guardianHidden),
    i_status: status,
    s_submissionDateBottom: submissionStartDatetime,
    s_submissionDateTop: submissionEndDate ? formatDate(submissionEndDate + submissionEndDateHour) : null,
    s_creationDateBottom: creationStartDate ? formatDate(creationStartDate + creationStartDateHour) : null,
    s_creationDateTop: creationEndDate ? formatDate(creationEndDate + creationEndDateHour) : null,
    s_serviceStopDateTop: actEndDate ? formatDate(actEndDate + actEndDateHour) : null,
    s_serviceStartDateBottom: actStartDate ? formatDate(actStartDate + actStartDateHour) : null,
    Categories: categories.reduce(function (obj, item, index) {
      return _objectSpread(_defineProperty({}, "#".concat(index), item), obj);
    }, {})
  };
};
export var getUniqueUUid = function getUniqueUUid(uniqueId, uuid) {
  return "".concat(uniqueId).concat(uniqueUUidSeparator).concat(uuid);
};
export var explodeUniqueUUid = function explodeUniqueUUid(uniqueUUid) {
  var _uniqueUUid$split = uniqueUUid.split(uniqueUUidSeparator),
    _uniqueUUid$split2 = _slicedToArray(_uniqueUUid$split, 2),
    uniqueId = _uniqueUUid$split2[0],
    uuid = _uniqueUUid$split2[1];
  return {
    uniqueId: uniqueId,
    uuid: uuid
  };
};
export var findDocumentByUniqueUUid = function findDocumentByUniqueUUid(documents, uniqueUUid) {
  return documents[uniqueUUid] || {};
};
export var findDocumentByUniqueId = function findDocumentByUniqueId(documents, uniqueId) {
  var exeptUuid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var docArray = Object.values(documents);
  return docArray.filter(function (document) {
    return document.s_uniqueId === uniqueId && (!exeptUuid || exeptUuid && document.s_uuid !== exeptUuid);
  });
};
export var findNewDocuments = function findNewDocuments(documents) {
  var docArray = Object.values(documents);
  return docArray.filter(function (document) {
    return document.isNew === true;
  });
};
export var getDocumentData = function getDocumentData(documentContent) {
  if (documentContent && documentContent.s_status === 'OK') {
    return documentContent.s_fileContentInBase64;
  }
  return null;
};
export var getCdaHeaders = function getCdaHeaders(documentContent) {
  if (documentContent && documentContent.s_status === 'OK') {
    return documentContent.s_cdaHeadersInBase64;
  }
  return null;
};
export var isMetaCategorySelected = function isMetaCategorySelected(selectedCategories, metaCategory) {
  if (!metaCategory) return false;
  if (selectedCategories === null) return false;
  if (selectedCategories.length === 0) return true;
  var childrenCategories = metaCategory.types;
  return childrenCategories.some(function (category) {
    return selectedCategories.includes(category.code);
  });
};
export var getFilteredMetaCategoriesIndex = function getFilteredMetaCategoriesIndex(metaCategories, selectedCategories) {
  var selectedMetas = [];
  if (!metaCategories) return selectedMetas;
  metaCategories.forEach(function (meta, index) {
    if (isMetaCategorySelected(selectedCategories, meta)) {
      selectedMetas.push(index);
    }
  });
  return selectedMetas;
};
export var isMetaCategoryFullyFiltered = function isMetaCategoryFullyFiltered(selectedCategories, metaCategory) {
  if (!metaCategory) return false;
  if (selectedCategories === null) return false;
  if (selectedCategories.length === 0) return true;
  var _metaCategory$types = metaCategory.types,
    childrenCategories = _metaCategory$types === void 0 ? [] : _metaCategory$types;
  return childrenCategories.every(function (category) {
    return selectedCategories.includes(category.code);
  });
};
export var getFullyFilteredMetaCategoriesIndex = function getFullyFilteredMetaCategoriesIndex(metaCategories, selectedCategories) {
  var selectedMetas = [];
  if (!metaCategories) return selectedMetas;
  metaCategories.forEach(function (meta, index) {
    if (isMetaCategoryFullyFiltered(selectedCategories, meta)) {
      selectedMetas.push(index);
    }
  });
  return selectedMetas;
};

/**
 * get the submission start date according to EX_3.1-1020
 * (cache the search results, and search only documents submitted since the last search timestamp)
 * @param findDocuments
 * @param findDocumentsParams
 * @return moment.Moment
 */
export var getDefaultSubmissionStartDate = function getDefaultSubmissionStartDate(findDocuments, findDocumentsParams) {
  var submissionStartDateHour = findDocumentsParams.submissionStartDateHour,
    submissionStartDate = findDocumentsParams.submissionStartDate;
  if (submissionStartDate) {
    return moment(submissionStartDate + submissionStartDateHour, 'DD/MM/YYYYHH:mm:ss');
  }
  if (isReady(findDocuments)) {
    var updatedAt = findDocuments.updatedAt;
    return moment(updatedAt);
  }
  return null;
};
var getDateFilter = function getDateFilter(columnName, startDate, startDateHour, endDate, endDateHour) {
  return {
    id: columnName,
    type: 'date',
    datemin: startDate ? moment(startDate + startDateHour, 'DD/MM/YYYYHH:mm:ss') : moment(0),
    datemax: endDate ? moment(endDate + endDateHour, 'DD/MM/YYYYHH:mm:ss') : moment()
  };
};
export var findDocumentParamsToFilters = function findDocumentParamsToFilters(params) {
  var status = params.status,
    submissionStartDate = params.submissionStartDate,
    submissionStartDateHour = params.submissionStartDateHour,
    submissionEndDate = params.submissionEndDate,
    submissionEndDateHour = params.submissionEndDateHour,
    creationStartDate = params.creationStartDate,
    creationStartDateHour = params.creationStartDateHour,
    creationEndDate = params.creationEndDate,
    creationEndDateHour = params.creationEndDateHour,
    actStartDate = params.actStartDate,
    actStartDateHour = params.actStartDateHour,
    actEndDate = params.actEndDate,
    actEndDateHour = params.actEndDateHour,
    patientHidden = params.patientHidden,
    guardianHidden = params.guardianHidden,
    healthcareProfessionalHidden = params.healthcareProfessionalHidden,
    categories = params.categories,
    title = params.title,
    author = params.author;
  var filters = [];
  filters.push({
    id: 'i_document_Visibility',
    type: 'value',
    value: calculateVisibility(patientHidden, healthcareProfessionalHidden, guardianHidden)
  });
  filters.push({
    id: 's_typeCode',
    type: 'array',
    array: categories
  });
  if (creationStartDate || creationEndDate) {
    filters.push(getDateFilter('s_creationDate', creationStartDate, creationStartDateHour, creationEndDate, creationEndDateHour));
  }
  if (actStartDate || actEndDate) {
    filters.push(getDateFilter('s_serviceStartDate', actStartDate, actStartDateHour, actEndDate, actEndDateHour));
    filters.push(getDateFilter('s_serviceStopDate', actStartDate, actStartDateHour, actEndDate, actEndDateHour));
  }
  if (submissionStartDate || submissionEndDate) {
    filters.push(getDateFilter('s_submissionDate', submissionStartDate, submissionStartDateHour, submissionEndDate, submissionEndDateHour));
  }
  filters.push({
    id: 'i_document_Status',
    type: 'value',
    value: status
  });
  filters.push({
    id: 's_title',
    type: 'string',
    value: title
  });
  filters.push({
    id: 'Authors',
    type: 'authors',
    value: author
  });
  return filters;
};
export var filterDocument = function filterDocument(filter, document) {
  var id = filter.id,
    _filter$value = filter.value,
    value = _filter$value === void 0 ? null : _filter$value,
    _filter$datemin = filter.datemin,
    datemin = _filter$datemin === void 0 ? null : _filter$datemin,
    _filter$datemax = filter.datemax,
    datemax = _filter$datemax === void 0 ? null : _filter$datemax,
    array = filter.array,
    type = filter.type;
  if (type === 'array') {
    return array !== null && (array.length === 0 || array.indexOf(document[id]) > -1);
  }
  if (type === 'value' && value && value !== 0) {
    return document[id] === value;
  }
  if (type === 'date' && (datemin || datemax)) {
    var momentValue = moment(document[id], 'YYYYMMDDHHmmss');
    return momentValue.isBetween(datemin, datemax, null, '[]');
  }
  if (type === 'string' && value) {
    return document[id].toLowerCase().indexOf(value.toLowerCase()) !== -1;
  }
  if (type === 'authors' && value) {
    return document.Authors.findIndex(function (author) {
      return author.s_hpName.concat(author.s_hpGiven).toLowerCase().indexOf(value.toLowerCase()) !== -1;
    }) !== -1;
  }
  return true;
};
export var getCategoryCounts = function getCategoryCounts(metaCategories, documents) {
  if (documents === undefined) return metaCategories;
  var categoryCount = Object.values(documents).reduce(function (acc, curr) {
    acc[curr.s_typeCode] = acc[curr.s_typeCode] || {
      count: 0,
      new: 0
    };
    acc[curr.s_typeCode].count += 1;
    if (curr.isNew === true) acc[curr.s_typeCode].new += 1;
    return acc;
  }, {});
  var metaCategoriesCount = [];
  metaCategories.forEach(function (meta, index) {
    // JSON.parse(JSON.stringify(meta)) pour copier l'objet sans référence
    metaCategoriesCount[index] = _objectSpread({}, JSON.parse(JSON.stringify(meta)), {
      count: 0,
      new: 0
    });
    meta.types.forEach(function (category, indexCat) {
      var count = categoryCount[category.code] || {
        count: 0,
        new: 0
      };
      metaCategoriesCount[index].types[indexCat] = _objectSpread({}, category, count);
      metaCategoriesCount[index].count += count.count;
      metaCategoriesCount[index].new += count.new;
    });
  });
  return metaCategoriesCount;
};
export var getFilteredDocuments = function getFilteredDocuments(documents, params) {
  var filters = findDocumentParamsToFilters(params);
  return Object.values(documents).filter(function (document) {
    return filters.every(function (filter) {
      return filterDocument(filter, document);
    });
  });
};
export var getFindDocumentsParams = function getFindDocumentsParams(state) {
  var params = state.dmpconnectUser.findDocumentsParams;
  return _objectSpread({}, params);
};
export var getFindDocumentsLastSearchTimeStamp = function getFindDocumentsLastSearchTimeStamp(state) {
  var ins = state.dmpconnect.selectedIns,
    _state$dmpconnectUser = state.dmpconnectUser.findDocumentsCache,
    _state$dmpconnectUser2 = _state$dmpconnectUser === void 0 ? {} : _state$dmpconnectUser,
    _state$dmpconnectUser3 = _state$dmpconnectUser2[ins],
    _state$dmpconnectUser4 = _state$dmpconnectUser3 === void 0 ? {} : _state$dmpconnectUser3,
    _state$dmpconnectUser5 = _state$dmpconnectUser4.timestamp,
    lastSearchTimestamp = _state$dmpconnectUser5 === void 0 ? null : _state$dmpconnectUser5;
  return lastSearchTimestamp;
};